<div class="detail-page-card">
    <div class="detail-page-card-title">{{ 'event.eventComments.commentsTitle' | transloco }}</div>
    <div class="detail-page-card-body">
        @if (isLoading) {
            <div class="fancy-loader submodule my-4"></div>
        } @else {
            <div>
                @if (comments && comments.length > 0) {
                    <div class="comments">
                        <div class="row headers">
                            <div class="col-5">{{ 'event.eventComments.columnComment' | transloco }}</div>
                            <div class="col">{{ 'event.eventComments.columnType' | transloco }}</div>
                            <div class="col">{{ 'event.eventComments.columnUser' | transloco }}</div>
                            <div class="col">{{ 'event.eventComments.columnDate' | transloco }}</div>
                        </div>

                        @for (comment of scopedComments; track comment) {
                            <div
                                class="row comment-row"
                                [class.comment-deleted]="comment.isDeleted"
                            >
                                <div class="col-5">
                                    @if (comment.comment) {
                                        <span>{{ comment.comment }}</span>
                                    } @else {
                                        <i style="font-size: 0.8em">{{ 'event.eventComments.noCommentGiven' | transloco }}</i>
                                    }
                                </div>
                                <div class="col">{{ comment.commentType }}</div>
                                <div class="col">{{ comment.createdBy }}</div>
                                <div class="col">{{ comment.createdAt | dateFormat }}</div>
                            </div>
                        }
                    </div>
                    @if (comments.length > 5) {
                        <div class="more-comments" (click)="showAllClick(!showAll)">
                            {{ (showAll ? ('event.eventComments.viewLastFive' | transloco) : ('event.eventComments.viewAll' | transloco : { count: comments.length })) }}
                        </div>
                    }
                } @else {
                    <div class="no-comments">{{ 'event.eventComments.noCommentsAvailable' | transloco }}</div>
                }
            </div>
        }
    </div>
</div>
